import React, { Component } from "react"
import styles from "./styles.css"
import FontIcon from "react-toolbox/lib/font_icon"
import { withRouter } from "react-router-dom"
import {
  formatDate,
  formatCurrency,
} from "../../../utils"
import { connect } from "react-redux"
import * as strings from "../../../strings"
import { toastr } from "react-redux-toastr"
import _ from "lodash"
import PaymentDialog from "./PaymentDialog"
import * as actions from "../../../actions"
import download from "downloadjs"

class PaymentsTracking extends Component {
  props: {
    payments: any,
    onChange: any,
    invoiceDocuments: any,
    paymentAgreementId: any,
    auth: {
      token: string,
    }
  }

  state = {
    dialogPayment: undefined,
    dialogVisible: false,
  }


  hideDialog = () => this.setState( {
    dialogPayment: undefined,
    dialogVisible: false,
  } )

  showDialog = () => this.setState( {
    dialogVisible: true,
  } )

  showPayment = ( payment ) => () => this.setState( {
    dialogPayment: payment,
    dialogVisible: true,
  } )

  downloadPaymentDocument = async payment => {
    const { auth } = this.props
    const _document = payment.documents[ 0 ]

    await actions.getPaymentDocument( auth.token, payment.id, _document.id )
      .then( response => {
        if ( response.status !== 200 ) {
          throw "Error downloading file"
        }

        const contentType = response.headers.get( "Content-type" )
        return response.blob()
          .then( blob => ( {
            contentType,
            blob,
          } ) )
      } )
      .then( file => download( file.blob, _document.name, file.contentType ) )
      .catch( () => toastr.error( strings.errorMessages.downloadError ) )
  }

  createPayment = async newPayment => {
    const { auth, paymentAgreementId } = this.props
    const preparedPayment = {
      ...newPayment,
      idPaymentAgreement: paymentAgreementId,
    }

    const response = await actions.addPayment( auth.token, preparedPayment )
    if ( response.message !== "OK" ) {
      return undefined
    }


    let finalPayment = response.result
    if ( newPayment.documents ) {
      const res = await actions.addPaymentDocument(
        auth.token,
        finalPayment.id,
        newPayment.documents
      )
      finalPayment.documents = res.result
    }

    return finalPayment
  }

  updatePayment = async newPayment => {
    const { auth, paymentAgreementId } = this.props

    const newPreparedPayment = {
      ...newPayment,
      idPaymentAgreement: paymentAgreementId,
    }
    const response = await actions.updatePayment( auth.token, newPreparedPayment )

    if ( response.message !== "OK" ) {
      return undefined
    }

    let finalPayment = response.result

    const previousDocuments = _.chain( this.props )
      .get( "payments", [] )
      .find( { id: newPayment.id } )
      .get( "documents", [] )
      .value()

    const hasPreviousDocuments = previousDocuments.length !== 0
    const documentsDiffer = !_.isEqual( previousDocuments, ( newPayment.documents || [] ) )

    if ( documentsDiffer && hasPreviousDocuments ) {
      await actions.deletePaymentDocument( auth.token, newPayment.id )
      finalPayment.documents = []
    }

    if ( newPayment.documents instanceof File ) {
      const res = await actions.addPaymentDocument(
        auth.token,
        response.result.id,
        newPayment.documents
      )
      finalPayment.documents = res.result
    }

    return finalPayment
  }

  savePayment = async payment => {
    const isAddingPayment = !payment.id

    let newPayment
    if ( isAddingPayment ) {
      newPayment = await this.createPayment( payment )
    } else {
      newPayment = await this.updatePayment( payment )
    }

    if ( !newPayment ) {
      toastr.error( strings.generalStrings.errorSaving )
      return
    }

    const newPaymentList = _.chain( this.props )
      .get( "payments", [] )
      .filter( p => p.id !== newPayment.id )
      .union( [ newPayment ] )
      .value()

    toastr.success( strings.generalStrings.paymentSaved )
    this.props.onChange( newPaymentList )
    this.hideDialog()
  }

  deletePayment = async payment => {
    const { auth } = this.props
    if ( payment.id ) {
      await actions.removePayment( auth.token, payment.id )
    }

    const newPaymentsArray = this.props.payments
      .filter( lp => lp.id !== payment.id )

    this.props.onChange( newPaymentsArray )
    this.hideDialog()
  }

  renderPaymentsTable () {
    const sortedPayments = _.chain( this.props.payments )
      .map( payment => ( {
        ...payment,
        paymentDate: new Date( payment.paymentDate ),
      } ) )
      .orderBy( [ "paymentDate", "id" ], [ "asc", "asc" ] )
      .value()

    return (
      <div className={styles.paymentsTable}>
        <table className={styles.tableCss}>
          <thead>
            <tr className={styles.borderBottom}>
              <td className={styles.clearFix}/>
              <td className={styles.tdTitle}>{strings.paymentAgreements.payment}</td>
              <td className={styles.tdTitle}>{strings.generalStrings.value}</td>
              <td className={styles.tdTitle}>{strings.generalStrings.receptionDate}</td>
              <td className={styles.tdTitle}>{strings.paymentAgreements.paymentMethod}</td>
            </tr>
          </thead>
          <tbody>
            {sortedPayments.map( ( payment, i ) => {
              const paymentInfo = [
                i + 1,
                formatCurrency( payment.value ),
                payment.paymentDate ? formatDate( payment.paymentDate ) : "--",
                _.get( payment, "paymentMethod", "--" ),
              ]
              return (
                <tr key={i}>
                  <td>
                    <div
                      className={styles.clearFix}
                      onClick={() => this.deletePayment( payment )}
                    >
                      <FontIcon>clear</FontIcon>
                    </div>
                  </td>
                  {paymentInfo.map( ( info, j ) => (
                    <td key={j}>
                      <div
                        style={{ "cursor": "pointer" }}
                        onClick={this.showPayment( payment )}
                      >
                        {info}
                      </div>
                    </td> )
                  ) }
                </tr>
              )
            } )}
          </tbody>
        </table>
      </div>
    )
  }

  render () {
    return (
      <div className={styles.paymentAgreementPlan}>
        <PaymentDialog
          visible={this.state.dialogVisible}
          payment={this.state.dialogPayment}
          savePayment={this.savePayment}
          deletePayment={this.deletePayment}
          downloadPaymentDocument={this.downloadPaymentDocument}
          cancel={this.hideDialog}
        />
        {this.renderPaymentsTable()}
        <div onClick={this.showDialog} className={styles.divButtonSubmit}>
          {strings.paymentAgreements.addPayment}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
  }
}

export default connect( mapStateToProps )( withRouter( PaymentsTracking ) )



// WEBPACK FOOTER //
// ./src/views/PaymentAgreement/PaymentsTracking/index.jsx